import React from "react";
import "./GlobalPresence.css";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PublicIcon from "@mui/icons-material/Public";
import ApartmentIcon from "@mui/icons-material/Apartment";
import globalPresenceMap from "../img/New/mapwithtext.png";

const GlobalPresence = () => {
  return (
    <section className="oglitz-global-presence">
      <div className="oglitz-global-presence-container">
        {/* LEFT CONTENT */}
        <div className="oglitz-global-presence-content">
          <span className="oglitz-global-presence-badge">
            Global Operations
          </span>

          <h2>
            Our Global <span>Presence</span>
          </h2>

          <p>
            Oglitz Software operates with a global delivery mindset, serving
            businesses across regions with reliable, scalable, and secure IT
            solutions. Our physical presence and distributed teams enable us to
            support clients efficiently across time zones.
          </p>

          <div className="oglitz-global-presence-locations">
            <div className="oglitz-location-card">
              <LocationOnIcon />
              <div>
                <h4>India (Headquarters)</h4>
                <p>Primary delivery & engineering hub</p>
              </div>
            </div>

            <div className="oglitz-location-card">
              <ApartmentIcon />
              <div>
                <h4>Dubai, UAE</h4>
                <p>Middle East operations & client support</p>
              </div>
            </div>

            <div className="oglitz-location-card">
              <PublicIcon />
              <div>
                <h4>Global Clients</h4>
                <p>Serving businesses across multiple countries</p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT VISUAL */}
        <div className="oglitz-global-presence-visual">
          <img
            src={globalPresenceMap}
            alt="Oglitz global presence map highlighting India and Dubai"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default GlobalPresence;
